import fetch from 'utils/fetch';

export const create = json => {
  return fetch('/pco-manager/cases-creation/new', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  });
};

export const update = (id, step, json, next) => {
  const paramStr = () => {
    if (step) {
      return `?step=${step}&next=${next}`;
    } else {
      return `?next=${next}`;
    }
  };

  return fetch(`/pco-manager/cases-creation/${id}${paramStr()}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  });
};

export const saveForLater = (id, json) =>
  fetch(`/pco-manager/cases-creation/${id}/saveForLater`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  });

export const saveAndGenerate = (id, json) =>
  fetch(`/pco-manager/cases-creation/${id}/saveAndGenerate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  });



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/api/index.js